export interface AppTheme {
  id: string;
  name: string;
  colors: {
    primary: string;
    secondary?: string;
    accent?: string;
    background?: string;
    surface?: string;
    colorPrimary?: string;
    colorPrimaryBg?: string;
    colorPrimaryBgHover?: string;
    colorPrimaryBorder?: string;
    colorPrimaryBorderHover?: string;
    colorPrimaryHover?: string;
    colorPrimaryActive?: string;
    colorPrimaryTextHover?: string;
    colorPrimaryText?: string;
    colorPrimaryTextActive?: string;
    colorBorderSecondary: string;
  };
  branding: {
    logo: string;
    logoOnly?: string;
    favicon?: string;
    appName: string;
    description?: string;
  };
  meta: {
    title: string;
    ogTitle: string;
    ogDescription: string;
    ogUrl: string;
    ogImage: string;
  };
}

enum AppsIds {
  AIVARD = 'aivard',
  YAGEL = 'yagel',
}

export const APP_THEMES: Record<string, AppTheme> = {
  [AppsIds.AIVARD]: {
    id: AppsIds.AIVARD,
    name: 'Aivard',
    colors: {
      primary: '#8747DF',
      secondary: '#6532B8',
      accent: '#E6CCFF',
      background: '#F5F5F5',
      surface: '#FFFFFF',
      colorPrimary: '#8747DF',
      colorPrimaryBg: '#F9F0FF',
      colorPrimaryBgHover: '#F8F0FF',
      colorPrimaryBorder: '#E6CCFF',
      colorPrimaryBorderHover: '#C99EF7',
      colorPrimaryHover: '#A871EB',
      colorPrimaryActive: '#6532B8',
      colorPrimaryTextHover: '#A871EB',
      colorPrimaryText: '#8747DF',
      colorPrimaryTextActive: '#6532B8',
      colorBorderSecondary: '#F0F0F0'
    },
    branding: {
      logo: '/icons/aivard/logo.svg',
      logoOnly: '/icons/aivard/logo-only.svg',
      favicon: '/favicon.ico',
      appName: 'Aivard',
      description: 'Manage your digital assets with ease'
    },
    meta: {
      title: 'Aivard',
      ogTitle: 'Aivard - Manage your digital assets with ease',
      ogDescription: 'Organize your work assets, share them with your team and partners, keep everything up to date — and never lose a file again.',
      ogUrl: 'https://aivard.com/',
      ogImage: 'https://aivard.com/og-logo.png'
    }
  },
  [AppsIds.YAGEL]: {
    id: AppsIds.YAGEL,
    name: 'Yagel',
    colors: {
      primary: '#605dff',
      secondary: '#6532B8',
      accent: '#E6CCFF',
      background: '#F5F5F5',
      surface: '#FFFFFF',
      colorPrimary: '#605dff',
      colorPrimaryBg: '#f3f0ff',
      colorPrimaryBgHover: '#f2f0ff',
      colorPrimaryBorder: '#dbd6ff',
      colorPrimaryBorderHover: '#b4adff',
      colorPrimaryHover: '#8b85ff',
      colorPrimaryActive: '#4346d9',
      colorPrimaryTextHover: '#8b85ff',
      colorPrimaryText: '#605dff',
      colorPrimaryTextActive: '#4346d9',
      colorBorderSecondary: '#F0F0F0'
    },
    branding: {
      logo: '/icons/yagel/logo.svg',
      logoOnly: '/icons/yagel/logo-only.svg',
      favicon: '/favicon.ico',
      appName: 'Yagel',
      description: 'Manage your digital assets with ease'
    },
    meta: {
      title: 'Yagel',
      ogTitle: 'Yagel - Manage your digital assets with ease',
      ogDescription: 'Organize your work assets, share them with your team and partners, keep everything up to date — and never lose a file again.',
      ogUrl: 'https://dam.cloudike.com/',
      ogImage: 'https://dam.cloudike.com/og-logo.png'
    }
  },
}

export const getThemeById = (themeId: string): AppTheme => {
  return APP_THEMES[themeId] || APP_THEMES['aivard']
}

export const getThemeByAppId = (appId: string): AppTheme => {
  return getThemeById(appId)
}
